module.exports = __webpack_public_path__ + "img/0-lg.bd566a30.jpg";